export const rootId = 0;
export const defaultMinDurationMs = 1000;
